import { Link } from "react-router-dom";
import forward from "../../asserts/images/forward.svg";
import Contactinfo from "./Contactinfo";
import Contactmap from "./contactmap";
import "./contactus.scss";
const Contact = () => {
  return (
    <div className="row">
      <div className="contact-box">
        <p className="path">
          <Link to="/home">Home</Link> <img src={forward} className="pb-1" />
          Contact us
        </p>
        <h1 className="col-lg-8 col-md-12 contact-heading">
          Need Assistance? <br />
          Reach Out to Our Support Team.
        </h1>
      </div>
      <Contactinfo></Contactinfo>
      <Contactmap></Contactmap>
    </div>
  );
};
export default Contact;
